import useJwt from '@/auth/jwt/useJwt';

export const isUserLoggedIn = () => localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName);

export const getUserData = () => JSON.parse(localStorage.getItem('userData'));

export const getHomeRouteForLoggedInUser = (userRole) => ({ name: 'remains' });
